// unblock when ajax activity stops
$(document).ajaxStop($.unblockUI);

function checkHtmlElements(order_type,image_mode,shouldPoll = false) {
    const elementIds = [
        "od_preview",
        "od_design_1",
        "od_design_2",
        "original_design_1_name"
    ];

    // 特定の条件下で追加の要素をチェック
    if (order_type === "da" && image_mode === "b") {
        elementIds.push("original_design_2_name");
    }

    // 全ての要素が存在するかチェック
    const checkElements = () => elementIds.every(id => document.getElementById(id) !== null);

    if (!shouldPoll) {
        return Promise.resolve(checkElements());
    }

    return new Promise((resolve) => {
        let timeoutLimit = 5000; // タイムアウトまでの時間（ミリ秒）
        let hasTimedOut = false;
        let checkInterval = 1000; // チェック間隔（ミリ秒）

        const intervalId = setInterval(() => {
            if (checkElements()) {
                // チェックパス
                clearInterval(intervalId);
                resolve(true);
            } else if (hasTimedOut) {
                // タイムアウト
                clearInterval(intervalId);
                resolve(false);
            }
        }, checkInterval);

        setTimeout(() => {
            hasTimedOut = true;
        }, timeoutLimit);
    });
}


$(function () {
    //jQuery BlockUIの設定
    $.blockUI.defaults.themedCSS.width = "auto";
    $.blockUI.defaults.themedCSS.top = "50%";
    $.blockUI.defaults.themedCSS.left = "50%";
    $.blockUI.defaults.themedCSS.transform = "translate(-50%, -50%)";
    $.blockUI.defaults.css.width = "auto";
    $.blockUI.defaults.css.top = "50%";
    $.blockUI.defaults.css.left = "50%";
    $.blockUI.defaults.css.transform = "translate(-50%, -50%)";
    ///////////////start param setting//////////
    const timeout_limit = 1000 * 30; //タイムアウト30秒
    const stageW = 400; //canvasステージ幅
    const stageH = 400; //canvasステージ高さ
    const min_size = 1700;
    const canvas_id = "ord_canvas";
    const btn_expand_id = "btn_expand";
    const btn_reduct_id = "btn_reduct";
    const btn_rotate_id = "btn_rotate";
    const btn_reverse_id = "btn_reverse";
    const btn_reverse_copy_id = "btn_reverse_copy";
    //const sel_color_id = 'color';

    /* カバーの各パーツのサイズはサイズごとに別途ymlで設定され読み込み*/
    var canvas; //cavas
    var stage; //stage（実際に操作するエリア）

    var up_img1, up_img2; //アップロードされる画像オブジェクト
    var item_type = $("#item_type").val(); //da:手帳型（表、裏、ベルト面） gl:表面のみ
    var gadget_image; //ガジェット（デザインフレーム）画像
    var overlay_grid_image_1, overlay_grid_image_2; //画像アップしたときに表示されるグリッドライン
    var img_front, img_back, img_belt; //正面画像、背面画像、ベルト部画像
    var cnt_main = new createjs.Container(); //stage背景用コンテナ
    var cnt_gadget = new createjs.Container(); //ガジェット用コンテナ
    var graphics; //表、裏など一面あたりの画像（汎用）
    var stage_bg; //背景
    var cnt_front, cnt_back, cnt_belt; //表側/裏側/ベルト側コンテナ
    var mask_front, mask_back, mask_belt; //表側/裏側/ベルト側マスクオブジェクト
    var shape_custom; //現在操作しているオブジェクトのShapeパーツ
    var graphics_frame; //現在操作しているオブジェクトのgraphicsパーツ

    var sel_mode_id = "design_mode";
    var btn_action_id;
    var continued = false;
    var eventLabel_touch = "mousedown";
    var eventLabel_up = "mouseup";
    var eventLabel_leave = "mouseleave";
    var is_sp = false; //true:現在の環境がスマートフォン
    var is_spDrag = false; //true:ドラッグON（スマートフォン時）
    var is_collabo_belt = false; //true:表側画像とベルト画像の連携
    var edit_image = 1; //1:表側画像 2:裏側画像
    var target_obj = null;
    var order_mode = "c"; //デザインモード a or b or c
    var long_line;
    var original_width, original_height;
    var collage_data; //位置座標など合成画像データ

    if (item_type === "dt") {
        order_mode = "b";
    }
    ///////////////end param setting//////////
    /**
     * ガジェットデータ取得後に画面描画
     */
    //$.blockUI({ message: $('#intialMessage')}); //BlockingUI
    init();
    // カートに入れるボタン クリックイベント
    $("#cart_btn").on("click", async function (event) {
        try {
            $.blockUI({ message: $("#domMessage") }); //BlockingUI @see /ordermade/script.js
            if (item_type === "da") {
                //ORDER-DGP）
                let sel0 = $("#original_design_1_name").val();
                if (sel0 == "") {
                    throw new Error('画像を設定してください');
                }  
                if(order_mode === "b"){
                    let sel1 = $("#original_design_2_name").val();
                    if (sel1 == "") {
                        throw new Error('表側デザイン画像を設定してください');
                    }    
                }         
            } else if (item_type === "dt" || item_type === 'gl' || item_type === 'uv'  ||item_type === 'gp') {
                let sel0 = $("#original_design_1_name").val();
                if (sel0 == "") {
                    throw new Error('画像を設定してください');
                }
                if (item_type === "dt"){
                    //名入れ文字チェック（ORDER-DTP）
                    let sel2_name = $('input[name="properties[名入れ文字]"]').val();
                    if (sel2_name == "") {
                        throw new Error(naire_err_msg);
                    } else if (!checkEmoji(sel2_name)) {
                        //@see ordermade/index.tpl
                        throw new Error(emoji_err_msg); //@see ordermade/index.tpl
                    }
                }             
            }

            // レイアウト画像 fix
            overlay_grid_image_1.visible = false; //センタガイドグリッド非表示
            if (item_type === "da") {
                overlay_grid_image_2.visible = false; //センタガイドグリッド非表示
            }

            stage.update();
            var info_front = null,
                info_belt = null,
                info_back = null;
            // POST前にHTML側タグのチェック
            const check_html = await checkHtmlElements(item_type, order_mode,true);

            if (!check_html) {
                throw new Error("データアップロード時にエラーが発生しました。もう一度お試しいただくか、お問い合わせよりご連絡下さい。");
            }
            //POST前にHTML側タグのチェックここまで

            if ($("#original_design_1_name").val().length > 0) {
                info_front = {
                    scaleX: img_front.scaleX,
                    scaleY: img_front.scaleY,
                    x: img_front.x,
                    y: img_front.y,
                    rotation: img_front.rotation,
                };
                if (item_type === "da" || item_type === "dt") {
                    info_belt = { x: img_belt.x, y: img_belt.y };
                }
            }

            if (
                item_type === "da" &&
                ($("#original_design_2_name").val().length > 0 ||
                    typeof img_back !== "undefined")
            ) {
                info_back = {
                    scaleX: img_back.scaleX,
                    scaleY: img_back.scaleY,
                    x: img_back.x,
                    y: img_back.y,
                    rotation: img_back.rotation,
                };
            }
            collage_data = { front: info_front, belt: info_belt, back: info_back };

            const result = await upload_layout_image($("#" + canvas_id).get(0).toDataURL("image/png"));
            if (!result || !result.path || !result.path.includes(".png")) {
                throw new Error("データアップロード時にエラーが発生しました。もう一度お試しいただくか、お問い合わせよりご連絡下さい。");
            }

            // アップロード成功時の処理
            $('input[name="properties[イメージ画像]"]').val(result.path);
            $("#od_design_1").val($("#original_design_1_name").val());
            let design2_name = $("#original_design_2_name").val();
            if (design2_name) {
                $("#od_design_2").val(design2_name);
            }
            if (!validateFormAndAddOptions()) {
                throw new Error("データ送信でエラーが発生しました。もう一度お試しいただくか、お問い合わせよりご連絡下さい。");
            }
            $(cart_id).submit();
        } catch (error) {
            alert(error.message);
            event.preventDefault();
            return false;
        } finally {
            $.unblockUI();
        }
    }); //end $('#cart_btn').on('click', function (event)

    // 表側デザインデータ セットイベント
    $("#original_design_1").on("change", function (event) {
        if (document.getElementById("original_design_1_name") === null) {
            $.unblockUI(); //BlockingUI @see /ordermade/script.js
            alert(
                "データアップロード時にエラーが発生しました。もう一度お試しいただくか、お問い合わせよりご連絡下さい。"
            );
            event.preventDefault();
            location.reload();
            return;
        }
        edit_image = 1;
        //失敗の場合は<input type="file"/>の初期化
        if (!setOriginalImage(this)) {
            if (!$(this).val()) {
                $(this).val("");
                $("#upload_msg_1").html(
                    '<div class="bs-component"><div class="alert alert-dismissible alert-warning"><p>JPG、PNGのデータをアップロードして下さい。<br>縦1700px以下の写真だと仕上がりが荒くなることがあります。</p></div></div>'
                );
            }
        }
    });
    // 裏側デザインデータ セットイベント
    $("#original_design_2").on("change", function (event) {
        if (document.getElementById("original_design_2_name") === null) {
            $.unblockUI(); //BlockingUI @see /ordermade/script.js
            alert(
                "データアップロード時にエラーが発生しました。もう一度お試しいただくか、お問い合わせよりご連絡下さい。"
            );
            event.preventDefault();
            location.reload();
            return;
        }
        edit_image = 2;
        //失敗の場合は<input type="file"/>の初期化
        if (!setOriginalImage(this)) {
            if (!$(this).val()) {
                $(this).val("");
                $("#upload_msg_2").html(
                    '<div class="bs-component"><div class="alert alert-dismissible alert-warning"><p>JPG、PNGのデータをアップロードして下さい。<br>縦1700px以下の写真だと仕上がりが荒くなることがあります。</p></div></div>'
                );
            }
        }
    });

    $("." + sel_mode_id).on("change", changeMode);

    /*
     * デザインモード変更前処理
     */
    function changeMode() {
        let type = $("." + sel_mode_id + ":checked").data("mode");
        if (item_type === "dt") {
            $('input[name="properties[フォトフレーム]"]').val(
                $("." + sel_mode_id + ":checked").val()
            );
            createjs.Tween.get(stage)
                .to({ alpha: 0 }, 1000, createjs.Ease.cubicOut)
                .call(changeGadget, [type], this); //フェードしてデザイン画像の差し替え
        } else {
            if (stage.numChildren < 3) {
                setDesignMode(type);
            } else {
                if (window.confirm("現在編集中のデザインはリセットされます")) {
                    setDesignMode(type);
                } else {
                    return false;
                }
            }
        }
    }
    /**
     * デザイン画像の差し替え
     * @param desing_no:デザイン名（デザインNo.）
     */
    function changeGadget(desing_no) {
        cnt_gadget.removeChild(gadget_image);
        gadget_image = new createjs.Bitmap(
            loadImg(
                baseURL +
                    "/images/ordermade/dt/" +
                    gadSize +
                    "/" +
                    desing_no +
                    ".png"
            )
        ); //デザイン@see ordermade/index.tpl
        cnt_gadget.addChild(gadget_image);
        createjs.Tween.get(stage).to(
            { alpha: 1 },
            1000,
            createjs.Ease.cubicInOut
        );
    }

    /*
     * デザインモード変更
     * @param type: a or b or c
     */
    function setDesignMode(type) {
        if (item_type === "da" || item_type === "dt") {
            cnt_back.removeAllChildren();
            cnt_belt.removeAllChildren();
        }
        cnt_front.removeAllChildren();
        stage.removeAllChildren();

        //ファイルアップロードの初期化
        //$('#up_img1 > div.formfile').html('<input type="file" id="original_design_1" class="form-control" required="required">');
        //$('#up_img2 > div.formfile').html('<input type="file" id="original_design_2" class="form-control" required="required">');
        $("#original_design_1").val("");
        $("#original_design_1_name").val("");
        $("#upload_msg_1").html(
            '<div class="bs-component"><div class="alert alert-dismissible alert-warning"><p>JPG、PNGのデータをアップロードして下さい。<br>縦1700px以下の写真だと仕上がりが荒くなることがあります。</p></div></div>'
        );

        if (item_type === "da") {
            $("#original_design_2").val("");
            $("#original_design_2_name").val("");
            $("#upload_msg_2").html(
                '<div class="bs-component"><div class="alert alert-dismissible alert-warning"><p>JPG、PNGのデータをアップロードして下さい。<br>縦1700px以下の写真だと仕上がりが荒くなることがあります。</p></div></div>'
            );
        }

        if (type === "b" && item_type !== "dt") {
            $("#frame_up_img2").fadeIn();
        } else {
            $("#frame_up_img2").fadeOut();
        }

        if (type === "c") {
            //ｃモードは表裏両面で一枚
            graphics = new createjs.Graphics()
                .beginFill("#ff0000")
                .drawRect(0, 0, gadGetW * 2, gadGetH);
            $("#" + btn_reverse_id)
                .fadeTo("normal", 0)
                .attr("disabled", true);
            $("#" + btn_reverse_copy_id)
                .fadeTo("normal", 0)
                .attr("disabled", true);
        } else {
            graphics = new createjs.Graphics()
                .beginFill("#ff0000")
                .drawRect(0, 0, gadGetW, gadGetH);
            $("#" + btn_reverse_id)
                .fadeTo("normal", 1)
                .attr("disabled", false);
            $("#" + btn_reverse_copy_id)
                .fadeTo("normal", 1)
                .attr("disabled", false);
        }

        mask_front = new createjs.Shape(graphics); //表側マスク
        if (item_type === "da" || item_type === "dt") {
            mask_belt = new createjs.Shape(graphics); //ベルト部マスク
        }

        //$('#' + sel_color_id).val(0);	//カラー変換初期化

        order_mode = type;
        cnt_main.addChild(stage_bg);
        cnt_gadget.addChild(gadget_image);
        stage.addChild(cnt_main);
        stage.addChild(cnt_gadget);
    }

    /**
     * 初期処理（外部から機種データ取得と描画処理）
     *
     */
    function init() {
        ///// start createJS set up/////
        if (item_type === "dt") {
            gadget_image = new createjs.Bitmap(
                loadImg(baseURL + "/images/ordermade/dt/" + gadSize + "/1.png")
            ); //デザイン@see ordermade/index.tpl
            $('input[name="properties[フォトフレーム]"]').val(
                $("." + sel_mode_id + ":checked").val()
            );
        } else {
            gadget_image = new createjs.Bitmap(
                loadImg(
                    baseURL +
                        "/images/ordermade/" +
                        item_type +
                        "/" +
                        $("#item_number").val() +
                        ".png"
                )
            ); //ベース画像
        }

        overlay_grid_image_1 = new createjs.Bitmap(
            loadImg(baseURL + "/fujicart-sc/ordermade/grid.png")
        );

        graphics = new createjs.Graphics()
            .beginFill("#ff0000")
            .drawRect(0, 0, gadGetW, gadGetH); //面のサイズ
        stage_bg = new createjs.Shape();
        stage_bg.graphics.beginFill("#ffffff").drawRect(0, 0, stageW, stageH); //面のサイズ

        cnt_front = new createjs.Container();
        mask_front = new createjs.Shape(graphics); //表側マスク

        //GLA、クリアケース型で不要なオブジェクトは生成しない
        if (item_type === "da" || item_type === "dt") {
            if (item_type === "da") {
                overlay_grid_image_2 = overlay_grid_image_1.clone();
            }
            cnt_back = new createjs.Container();
            cnt_belt = new createjs.Container();
            mask_back = new createjs.Shape(graphics);
            mask_belt = new createjs.Shape(graphics);
        } else {
            overlay_grid_image_2 = null;
            cnt_back = null;
            cnt_belt = null;
            mask_back = null;
            mask_belt = null;
        }
        ///// end createJS set up/////

        canvas = $("#" + canvas_id).get(0);
        stage = new createjs.Stage(canvas);
        cnt_main.addChild(stage_bg);
        cnt_gadget.addChild(gadget_image);
        stage.addChild(cnt_main);
        stage.addChild(cnt_gadget);
        //スマホの場合はイベント設定を変更
        if (
            navigator.userAgent.indexOf("iPhone") > 0 ||
            navigator.userAgent.indexOf("iPad") > 0 ||
            navigator.userAgent.indexOf("iPod") > 0 ||
            navigator.userAgent.indexOf("Android") > 0
        ) {
            is_sp = true;
            eventLabel_touch = "touchstart";
            eventLabel_up = "touchend";
            eventLabel_leave = "touchcancel";

            spAddScroll();
        }

        createjs.Ticker.timingMode = createjs.Ticker.RAF;
        createjs.Ticker.addEventListener("tick", function () {
            stage.update(); // フレーム単位でステージの描画が更新されるようになる
        });
        //タッチ操作をサポートしているブラウザーならば
        if (createjs.Touch.isSupported() === true) {
            // タッチ操作を有効にします。
            createjs.Touch.enable(stage);
        }
        setDesignMode(order_mode);
    }

    /**
     * 画像データを作成してcrossOrigin = "Anonymous"を付与
     * @param {*} uri
     * @returns
     */
    function loadImg(uri) {
        var image = document.createElement("img");
        image.crossOrigin = "Anonymous";
        image.src = uri;
        return image;
    }

    /**
     * 画像読み込み手続き
     * @param image_source
     */
    function imageLoad(image_source) {
        if (edit_image === 1) {
            //表側画像
            up_img1 = new Image();
            up_img1.crossOrigin = "Anonymous";
            up_img1.src = image_source;
            up_img1.onload = onLoadImage;
        } else if (edit_image === 2) {
            //裏側画像
            up_img2 = new Image();
            up_img2.crossOrigin = "Anonymous";
            up_img2.src = image_source;
            up_img2.onload = onLoadImage;
        }
    }

    /**
     * 実際の画像読み込み処理
     * 画像リサイズ、読み込んだ画像にJSイベント等設定
     *
     */
    function onLoadImage() {
        if (edit_image === 1) {
            //表側
            if (item_type === "da" || item_type === "dt") {
                is_collabo_belt = true;
            } else if (
                item_type === "gl" ||
                item_type === "uv" ||
                item_type === "gp"
            ) {
                is_collabo_belt = false;
            }

            if (cnt_front.numChildren > 0) {
                cnt_front.removeAllChildren();
                if (item_type === "da" || item_type === "dt") {
                    cnt_belt.removeAllChildren();
                }
            }
            img_front = new createjs.Bitmap(up_img1);
            original_width = img_front.getBounds().width;
            original_height = img_front.getBounds().height;
            if (
                (order_mode === "a" || order_mode === "c") &&
                item_type === "da"
            ) {
                if (cnt_back.numChildren > 0) {
                    cnt_back.removeAllChildren();
                }
                img_back = new createjs.Bitmap(up_img1);
                original_width = img_back.getBounds().width;
                original_height = img_back.getBounds().height;
            }
        } else if (edit_image === 2) {
            //裏側画像
            is_collabo_belt = false;
            if (cnt_back.numChildren > 0) {
                cnt_back.removeAllChildren();
            }
            img_back = new createjs.Bitmap(up_img2);
            original_width = img_back.getBounds().width;
            original_height = img_back.getBounds().height;
        }

        setSelectFrame(); //現在選択中のオブジェウトの設定

        var convert_width, convert_height; //リサイズ幅、リサイズ高さ

        if (original_width === original_height) {
            //正方形
            convert_width = gadGetH;
            convert_height = gadGetH;
            long_line = original_width;
        } else if (original_width >= original_height) {
            //横長
            var aspect = getReversAspect(gadGetH, original_height);
            convert_width = original_width * aspect;
            convert_height = gadGetH;
            long_line = original_width;
        } else {
            // 縦長
            var aspect = getReversAspect(gadGetH, original_height);
            convert_width = original_width * aspect;
            convert_height = gadGetH;
            long_line = original_height;
        }

        if (item_type !== "dt") {
            overlay_grid_image_1.regX =
                overlay_grid_image_1.getBounds().width / 2;
            overlay_grid_image_1.regY =
                overlay_grid_image_1.getBounds().height / 2;
            overlay_grid_image_1.x = gadGetW / 2;
            overlay_grid_image_1.y = gadGetH / 2;
        }
        if (item_type === "da") {
            overlay_grid_image_2.regX =
                overlay_grid_image_2.getBounds().width / 2;
            overlay_grid_image_2.regY =
                overlay_grid_image_2.getBounds().height / 2;
            overlay_grid_image_2.x = gadGetW / 2;
            overlay_grid_image_2.y = gadGetH / 2;
        }
        //コンテナの設定
        if (edit_image === 1) {
            //表側
            if (is_collabo_belt) {
                img_belt = img_front.clone();
            }

            if (item_type === "da" || item_type === "dt") {
                img_belt.id = 3;
            }

            img_front.id = 1;

            if (order_mode === "c") {
                //GLA、クリアケースはcモードのみ

                cnt_front.mask = mask_front;

                if (item_type === "da" || item_type === "dt") {
                    mask_front.x = cnt_front_X2;
                    mask_front.y = cnt_front_Y2;
                    cnt_front.x = cnt_front_X2;
                    cnt_front.y = cnt_front_Y2;
                    mask_belt.x = cnt_belt_X2;
                    mask_belt.y = cnt_belt_Y2;
                    cnt_belt.mask = mask_belt;
                    cnt_belt.x = cnt_belt_X2;
                    cnt_belt.y = cnt_belt_Y2;
                } else if (
                    item_type === "gl" ||
                    item_type === "uv" ||
                    item_type === "gp"
                ) {
                    mask_front.x = cnt_front_X;
                    mask_front.y = cnt_front_Y;
                    cnt_front.x = cnt_front_X;
                    cnt_front.y = cnt_front_Y;
                }
            } else {
                mask_belt.x = cnt_belt_X;
                mask_belt.y = cnt_belt_Y;
                cnt_belt.mask = mask_belt;
                cnt_belt.x = cnt_belt_X;
                cnt_belt.y = cnt_belt_Y;

                mask_front.x = cnt_front_X;
                mask_front.y = cnt_front_Y;
                cnt_front.mask = mask_front;
                cnt_front.x = cnt_front_X;
                cnt_front.y = cnt_front_Y;
            }

            cnt_front.addChild(img_front);
            // リサイズ

            img_front.scaleY = convert_height / original_height;
            if (
                item_type === "gl" ||
                item_type === "uv" ||
                item_type === "gp"
            ) {
                //gl,uv,gpは縦基準
                img_front.scaleX = convert_height / original_height;
            } else {
                img_front.scaleX = convert_width / original_width;
            }
            // 中央寄せ
            img_front.regX = img_front.getBounds().width / 2;
            img_front.regY = img_front.getBounds().height / 2;
            //グリッド設置
            if (item_type !== "dt") {
                cnt_front.addChild(overlay_grid_image_1);
            }

            if (item_type === "da" || item_type === "dt") {
                cnt_belt.addChild(img_belt);
                img_belt.scaleX = convert_width / original_width;
                img_belt.scaleY = convert_height / original_height;
            }

            if (order_mode === "c") {
                //GLA、クリアケースはcモードのみ
                img_front.x = gadGetW;

                if (item_type === "da") {
                    img_belt.x = gadGetW - belt_offset;
                    overlay_grid_image_1.x = gadGetW;
                } else if (
                    item_type === "gl" ||
                    item_type === "uv" ||
                    item_type === "gp"
                ) {
                    img_front.x = gadGetW / 2;
                    overlay_grid_image_1.x = gadGetW / 2;
                }
            } else {
                img_front.x = gadGetW / 2;
                img_belt.x = gadGetW / 2 - belt_offset;
                overlay_grid_image_1.x = gadGetW / 2;
            }

            img_front.y = gadGetH / 2;
            stage.addChild(cnt_front);

            if (item_type === "da" || item_type === "dt") {
                img_belt.regX = img_belt.getBounds().width / 2;
                img_belt.regY = img_belt.getBounds().height / 2;
                img_belt.y = gadGetH / 2;
                stage.addChild(cnt_belt);
            }

            if (order_mode === "a") {
                img_back.id = 2;
                mask_back.x = cnt_back_X;
                mask_back.y = cnt_back_Y;
                cnt_back.mask = mask_back;
                cnt_back.x = cnt_back_X;
                cnt_back.y = cnt_back_Y;
                cnt_back.addChild(img_back);

                // リサイズ
                img_back.scaleX = convert_width / original_width;
                img_back.scaleY = convert_height / original_height;

                // 中央寄せ
                img_back.regX = img_back.getBounds().width / 2;
                img_back.regY = img_back.getBounds().height / 2;
                img_back.x = gadGetW / 2;
                img_back.y = gadGetH / 2;

                cnt_back.addChild(overlay_grid_image_2);
                stage.addChild(cnt_back);
            }

            target_obj = img_front;

            shape_custom.x = cnt_front_X - 3;
            shape_custom.y = cnt_front_Y - 3;

            if (order_mode === "c") {
                shape_custom.visible = false;
            } else {
                shape_custom.visible = false; //ひとまず非表示（仕様未確定）
            }
        } else if (edit_image === 2) {
            //裏側画像
            img_back.id = 2;
            mask_back.x = cnt_back_X;
            mask_back.y = cnt_back_Y;
            cnt_back.mask = mask_back;
            cnt_back.x = cnt_back_X;
            cnt_back.y = cnt_back_Y;
            cnt_back.addChild(img_back);

            // リサイズ
            img_back.scaleX = convert_width / original_width;
            img_back.scaleY = convert_height / original_height;

            // 中央寄せ
            img_back.regX = img_back.getBounds().width / 2;
            img_back.regY = img_back.getBounds().height / 2;
            img_back.x = gadGetW / 2;
            img_back.y = gadGetH / 2;

            cnt_back.addChild(overlay_grid_image_2);
            stage.addChild(cnt_back);

            target_obj = img_back;

            shape_custom.x = cnt_back_X - 3;
            shape_custom.y = cnt_back_Y - 3;
            shape_custom.visible = false; //ひとまず非表示（仕様未確定）
        }

        stage.addChild(cnt_gadget);
        //setTimeout(stage.addChild(shape_custom), 1000); //この状態だとメモリーエラー
        stage.addChild(shape_custom); //現在操作しているオブジェクトを明示
        // オーバーレイグリッド画像を重ね合わせ
        // ガジェット画像を重ね合わせ

        stage.update();

        $("#" + btn_rotate_id).off("click");
        $("#" + btn_reverse_id).off("click");
        $("#" + btn_reverse_copy_id).off("click");
        //$('#' + sel_color_id).off('change');
        // ドラッグ操作
        if (is_sp) {
            //sp
            canvas.addEventListener(
                "touchstart",
                function (event) {
                    if (event.touches.length === 2) {
                        //２本指
                        is_spDrag = true;
                    } else {
                        is_spDrag = false;
                    }
                },
                false
            );

            if (edit_image === 1) {
                //表側
                if (img_back != null) {
                    img_back.removeEventListener(
                        "mousedown",
                        startDrag2,
                        false
                    );
                    img_back.addEventListener("mousedown", swapTarget);
                }
                target_obj = img_front;
                target_obj.addEventListener("mousedown", startDrag2);
            } else if (edit_image === 2) {
                //裏側
                if (img_front != null) {
                    img_front.removeEventListener(
                        "mousedown",
                        startDrag2,
                        false
                    );
                    img_front.addEventListener("mousedown", swapTarget);
                }
                target_obj = img_back;
                target_obj.addEventListener("mousedown", startDrag2);
            }
            spAddScroll();
        } else {
            //PC

            if (edit_image === 1) {
                //表側
                if (img_back != null) {
                    img_back.removeEventListener("mousedown", startDrag, false);
                    img_back.addEventListener("mousedown", swapTarget);
                }
                target_obj = img_front;
                target_obj.addEventListener("mousedown", startDrag);
            } else if (edit_image === 2) {
                //裏側
                if (img_front != null) {
                    img_front.removeEventListener(
                        "mousedown",
                        startDrag,
                        false
                    );
                    img_front.addEventListener("mousedown", swapTarget);
                }
                target_obj = img_back;
                target_obj.addEventListener("mousedown", startDrag);
            }
        }
        $("#" + btn_rotate_id).on("click", rotation(target_obj));
        $("#" + btn_reverse_id).on("click", reverse(target_obj));
        $("#" + btn_reverse_copy_id).on("click", reverse_copy(target_obj));
        //$('#' + sel_color_id).on('change', set_color());

        // ボタン操作
        $("#" + btn_expand_id)
            .on(eventLabel_touch, function () {
                continued = true;
                btn_action_id = setTimeout(expansion(target_obj), 100);
                return false;
            })
            .on(eventLabel_up, function () {
                continued = false;
                clearTimeout(btn_action_id);
            })
            .on(eventLabel_leave, function () {
                continued = false;
                clearTimeout(btn_action_id);
            });

        $("#" + btn_reduct_id)
            .on(eventLabel_touch, function () {
                continued = true;
                btn_action_id = setTimeout(reduction(target_obj), 100);
                return false;
            })
            .on(eventLabel_up, function () {
                continued = false;
                clearTimeout(btn_action_id);
            })
            .on(eventLabel_leave, function () {
                continued = false;
                clearTimeout(btn_action_id);
            });

        var up_msg;
        if (edit_image === 1) {
            up_msg = "upload_msg_1";
        } else if (edit_image === 2) {
            up_msg = "upload_msg_2";
        }

        if (long_line < min_size) {
            var hw_diff = Math.round(
                ((min_size - parseInt(long_line)) / min_size) * 100
            );
            $("#" + up_msg).html(
                '<div class="bs-component"><div class="alert alert-dismissible alert-warning"><span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span> 画像が' +
                    original_height +
                    "pxでしたので、" +
                    hw_diff +
                    "%ほど荒くなる可能性があります。1700px以上が推奨です。</div></div>"
            );
        } else {
            $("#" + up_msg).html(
                '<div class="bs-component"><div class="alert alert-dismissible alert-success"><span class="glyphicon glyphicon-ok-sign" aria-hidden="true"></span> 正常にアップロードされました</div></div>'
            );
        }
    }

    /**
     * canvas上で一定以上の運動量があった場合スクロール
     * 移動距離はスクロールしたY方向個の距離
     */
    function spAddScroll() {
        var canvas_area = "#" + canvas_id;
        var startY, endY;
        $(canvas_area).on("touchstart", function (event) {
            event.preventDefault();
            startY = 0;
            endY = 0;
            if (!is_spDrag) {
                if (event.originalEvent.touches.length > 1) {
                    return false;
                }
                startY = event.originalEvent.touches[0].pageY;
            }
        });
        $(canvas_area).on("touchmove", function (event) {
            event.preventDefault();
            if (!is_spDrag) {
                if (event.originalEvent.touches.length > 1) {
                    return false;
                }
                endY = event.originalEvent.touches[0].pageY;
            } else {
                endY = 0;
            }
        });
        $(canvas_area).on("touchend", function (event) {
            event.preventDefault();
            if (is_spDrag) {
                return false;
            }
            if (startY < 1 || endY < 1) {
                return false;
            }
            var currentTop = $(window).scrollTop();
            if (startY - endY != 0 && startY != 0) {
                var distY = 0;
                distY = currentTop + (startY - endY);
                $("html,body").animate({ scrollTop: distY }, 500, "swing");
            }

            return false;
        });
    }

    /*
     * 現在選択中のオブジェウトの設定
     */
    function setSelectFrame() {
        if (stage.contains(shape_custom)) {
            stage.removeChild(shape_custom);
        }
        shape_custom = new createjs.Shape(); //現在操作しているオブジェクトのShapeパーツ
        graphics_frame = shape_custom.graphics; //現在操作しているオブジェクトのgraphicsパーツ
        //現在選択している面を示す枠の設定（未使用）
        graphics_frame.beginStroke("#FF6600");
        graphics_frame.setStrokeStyle(2);
        graphics_frame.drawRoundRect(0, 0, gadGetW + 6, gadGetH + 6, 20, 20);
        shape_custom.alpha = 0;
        //createjs.Tween.get(shape_custom,{loop: true}).to({alpha:0.8}, 2000);
        shape_custom.visible = false; //ひとまず非表示（仕様未確定）

        createjs.Tween.get(shape_custom).to({ alpha: 0.8 }, 1000);
    }

    /**
     * 表、裏の編集の切り替え
     */
    function swapTarget(eventObject) {
        if (typeof img_front == "undefined" || typeof img_back == "undefined")
            return;

        //if(eventObject.target !== target_obj ){

        //現在操作しているものと逆にする
        $("#" + btn_rotate_id).off("click");
        $("#" + btn_reverse_id).off("click");
        $("#" + btn_reverse_copy_id).off("click");
        //$('#' + sel_color_id).off('change');
        target_obj = null;
        //同じターゲットを再度指定した場合の対応（ドラッグ＆ドロップで一旦選択から外れた後に再度同じターゲットを指定）
        var tmpId = eventObject.target.id;
        if (tmpId === 1 && edit_image === 1) {
            edit_image = 2;
        } else if (tmpId === 2 && edit_image === 2) {
            edit_image = 1;
        }

        setSelectFrame(); //現在選択中のオブジェウトの設定

        if (edit_image === 1) {
            //表⇒裏
            if (img_front != null) {
                img_front.removeAllEventListeners();
            } else {
                return;
            }

            target_obj = img_back;
            edit_image = 2;
            if (order_mode === "c") {
                is_collabo_belt = true;
            } else {
                is_collabo_belt = false;
            }

            shape_custom.x = cnt_back_X - 3;
            shape_custom.y = cnt_back_Y - 3;
            img_front.addEventListener("mousedown", swapTarget);
        } else if (edit_image === 2) {
            //裏⇒表
            if (img_back != null) {
                img_back.removeAllEventListeners();
            } else {
                return;
            }
            target_obj = img_front;
            edit_image = 1;
            is_collabo_belt = true;
            shape_custom.x = cnt_front_X - 3;
            shape_custom.y = cnt_front_Y - 3;
            img_back.addEventListener("mousedown", swapTarget);
        }

        $("#" + btn_rotate_id).on("click", rotation(target_obj));
        $("#" + btn_reverse_id).on("click", reverse(target_obj));
        $("#" + btn_reverse_copy_id).on("click", reverse_copy(target_obj));
        //$('#' + sel_color_id).on('change', set_color());

        if (!is_sp) {
            //PC
            startDrag(eventObject);
        } else {
            startDrag2(eventObject);
        }

        //}

        stage.addChild(shape_custom);

        //return false;
    }

    /*////////////スマホ用/のドラグ処理/////////////*/

    function startDrag2(eventObject) {
        eventObject.stopPropagation();
        var instance = eventObject.target;
        instance.addEventListener("pressmove", drag2);
        instance.addEventListener("pressup", stopDrag2);
        instance.offset = new createjs.Point(
            instance.x - stage.mouseX,
            instance.y - stage.mouseY
        );
    }

    function drag2(eventObject) {
        eventObject.stopPropagation();
        if (is_spDrag) {
            var instance = eventObject.target;
            var offset = instance.offset;
            instance.x = stage.mouseX + offset.x;
            instance.y = stage.mouseY + offset.y;
            if (is_collabo_belt) {
                img_belt.x = instance.x - belt_offset;
                img_belt.y = instance.y;
            }
            //stage.update();
        }
    }

    function stopDrag2(eventObject) {
        eventObject.stopPropagation();
        is_spDrag = false;

        var instance = eventObject.target;
        instance.removeEventListener("pressmove", drag2);
        instance.removeEventListener("pressup", stopDrag2);
        //return false;
    }

    /*////////////PC用のドラッグ処理///////////////*/

    function startDrag(eventObject) {
        var instance = eventObject.target;
        instance.addEventListener("pressmove", drag);
        instance.addEventListener("pressup", stopDrag);
        instance.offset = new createjs.Point(
            instance.x - eventObject.stageX,
            instance.y - eventObject.stageY
        );
    }

    function drag(eventObject) {
        var instance = eventObject.target;
        var offset = instance.offset;
        instance.x = eventObject.stageX + offset.x;
        instance.y = eventObject.stageY + offset.y;
        if (is_collabo_belt) {
            img_belt.x = eventObject.stageX + offset.x - belt_offset;
            img_belt.y = eventObject.stageY + offset.y;
        }

        stage.update();
    }

    function stopDrag(eventObject) {
        var instance = eventObject.target;
        instance.removeEventListener("pressmove", drag);
        instance.removeEventListener("pressup", stopDrag);
        target_obj = instance;
    }

    /**
     * 画像の拡大
     */
    function expansion(image) {
        return function (eventObject) {
            var currentW = Math.abs(
                Math.floor(image.getBounds().width * image.scaleX)
            );
            var speed = 0.003;
            if (currentW < gadGetW - 100) {
                speed = 0.001;
            }
            if (image.scaleX < 0) {
                image.scaleX = image.scaleX - speed;
            } else {
                image.scaleX = image.scaleX + speed;
            }

            image.scaleY = image.scaleY + speed;
            if (is_collabo_belt) {
                if (img_belt.scaleX < 0) {
                    img_belt.scaleX = img_belt.scaleX - speed;
                } else {
                    img_belt.scaleX = img_belt.scaleX + speed;
                }
                img_belt.scaleY = image.scaleY + speed;
                img_belt.uncache();
            }
            image.uncache();
            stage.update();
            // 処理継続判断
            if (continued === true) {
                setTimeout(expansion(image), 100);
            }
        };
    }

    /*
     * 画像の縮小
     */
    function reduction(image) {
        return function (eventObject) {
            var currentW = Math.abs(
                Math.floor(image.getBounds().width * image.scaleX)
            );
            var speed = 0.003;
            if (currentW < gadGetW - 100) {
                speed = 0.001;
            }
            if (image.scaleX < 0) {
                image.scaleX = image.scaleX + speed;
            } else {
                image.scaleX = image.scaleX - speed;
            }

            if (image.scaleY < 0) {
                image.scaleY = image.scaleY + speed;
            } else {
                image.scaleY = image.scaleY - speed;
            }

            if (is_collabo_belt) {
                if (img_belt.scaleX < 0) {
                    img_belt.scaleX = img_belt.scaleX + speed;
                } else {
                    img_belt.scaleX = img_belt.scaleX - speed;
                }

                if (img_belt.scaleY < 0) {
                    img_belt.scaleY = img_belt.scaleY + speed;
                } else {
                    img_belt.scaleY = img_belt.scaleY - speed;
                }
                img_belt.uncache();
            }
            image.uncache();
            stage.update();
            // 処理継続判断
            if (continued === true) {
                setTimeout(reduction(image), 100);
            }
        };
    }

    /*
     * 画像の回転（時計回り90度単位）
     */
    function rotation(image) {
        return function (eventObject) {
            image.rotation = image.rotation + 90;
            if (is_collabo_belt) {
                img_belt.rotation = img_belt.rotation + 90;
            }
            stage.update();
        };
    }

    /**
     * 折り目で左右反転
     */
    function reverse(image) {
        return function (eventObject) {
            var currentW = Math.abs(
                Math.floor(image.getBounds().width * image.scaleX)
            );
            var rotation = image.rotation;
            var tmpW = currentW;
            var cenX = gadGetW / 2; //強制的にガジェットの中央に合わせる

            var tmpRefleft = rotation / 90;
            if (tmpRefleft % 2 != 0) {
                tmpW = Math.abs(
                    Math.floor(image.getBounds().height * image.scaleY)
                );
                image.scaleY = image.scaleY * -1;
            } else {
                image.scaleX = image.scaleX * -1;
            }

            if (edit_image === 1) {
                //表側
                var posX = Math.floor(tmpW / 2);
                image.x = posX;
                if (tmpRefleft % 2 != 0) {
                    img_belt.scaleY = img_belt.scaleY * -1;
                } else {
                    img_belt.scaleX = img_belt.scaleX * -1;
                }

                img_belt.x = posX - belt_offset;
                img_belt.uncache();
            } else if (edit_image === 2) {
                //裏側
                if (tmpW >= gadGetW) {
                    var diffW = Math.floor((tmpW - gadGetW) / 2);
                    image.x = cenX - diffW;
                } else {
                    var diffW = Math.floor((gadGetW - tmpW) / 2);
                    image.x = cenX + diffW;
                }
            }

            image.uncache();
            stage.update();
        };
    }

    /*
     * 折り目で左右コピー
     */
    function reverse_copy(image) {
        return function (eventObject) {
            var currentW = Math.abs(
                Math.floor(image.getBounds().width * image.scaleX)
            );
            if (edit_image === 1) {
                //表側
                //裏側に画像コピー、位置を調整
                if (stage.contains(cnt_back)) {
                    cnt_back.removeAllChildren();
                } else {
                    mask_back.x = cnt_back_X;
                    mask_back.y = cnt_back_Y;
                    cnt_back.mask = mask_back;
                    cnt_back.x = cnt_back_X;
                    cnt_back.y = cnt_back_Y;
                    stage.addChild(cnt_back);
                    stage.addChildAt(cnt_back, stage.getChildIndex(cnt_gadget));
                }

                img_back = image.clone();
                cnt_back.addChild(img_back);

                img_back.id = 2;
                img_back.addEventListener("mousedown", swapTarget);
                img_back.addEventListener("mousedown", startDrag);
                $("#original_design_2_name").val(
                    $("#original_design_1_name").val()
                ); //ファイル名をセット
            } else if (edit_image === 2) {
                //裏側
                //表側とベルトに画像コピー
                if (stage.contains(cnt_front)) {
                    cnt_front.removeAllChildren();
                    cnt_belt.removeAllChildren();
                } else {
                    mask_front.x = cnt_front_X;
                    mask_front.y = cnt_front_Y;
                    cnt_front.mask = mask_front;
                    cnt_front.x = cnt_front_X;
                    cnt_front.y = cnt_front_Y;
                    stage.addChild(cnt_front);

                    mask_belt.x = cnt_belt_X;
                    mask_belt.y = cnt_belt_Y;
                    cnt_belt.mask = mask_belt;
                    cnt_belt.x = cnt_belt_X;
                    cnt_belt.y = cnt_belt_Y;
                    stage.addChild(cnt_belt);
                    stage.addChildAt(cnt_belt, stage.getChildIndex(cnt_gadget));
                    stage.addChildAt(
                        cnt_front,
                        stage.getChildIndex(cnt_gadget)
                    );
                }

                img_front = image.clone();
                img_belt = image.clone();

                cnt_front.addChild(img_front);
                cnt_belt.addChild(img_belt);

                img_front.id = 1;
                img_belt.id = 3;
                img_front.addEventListener("mousedown", swapTarget);
                img_front.addEventListener("mousedown", startDrag);
                $("#original_design_1_name").val(
                    $("#original_design_2_name").val()
                ); //ファイル名をセット
            }

            var nowX = gadGetW / 2; //強制的にガジェットの中央に合わせる
            var centerY = gadGetH / 2;
            var tmpW = Math.floor((currentW - gadGetW) / 2);
            img_back.x = nowX - tmpW;
            img_back.y = centerY;
            var posX = Math.floor(currentW / 2);
            img_front.x = posX;
            img_front.y = centerY;
            img_belt.x = posX - belt_offset;
            img_belt.y = centerY;

            img_back.uncache();
            img_front.uncache();
            img_belt.uncache();

            stage.update();
        };
    }

    /*
     * 画像のカラー調整
     */
    /*
  function set_color()
  {
    return function (eventObject) {
      var type = $('#color option:selected').data("type");

      // 編集画像を設定
	  img_front.cache(0,0,img_front.getBounds().width,img_front.getBounds().height);
	  img_belt.cache(0,0,img_belt.getBounds().width,img_belt.getBounds().height);
	  img_back.cache(0,0,img_back.getBounds().width,img_back.getBounds().height);

      if (type === 'gray') {
        gray(img_front);
		gray(img_belt);
		gray(img_back);
      } else if (type === 'sepia') {
        sepia(img_front);
		sepia(img_belt);
		sepia(img_back);
      } else {
        original(img_front);
		original(img_belt);
		original(img_back);
      }
	  updateDesingImage();	//カラー調整した画像の再UP
      stage.update();
    }
  }
*/

    /**
     * 画像の色調変化を元に戻す
     * @param {type} image
     * @returns {undefined}
     */
    function original(image) {
        image.filters = [];
        image.updateCache();
    }

    /**
     * 画像のグレイスケール化
     * @param {type} image
     * @returns {undefined}
     */
    function gray(image) {
        var gray_filter = new createjs.ColorMatrixFilter([
            0.3,
            0.3,
            0.3,
            0,
            0, // red component
            0.3,
            0.3,
            0.3,
            0,
            0, // green component
            0.3,
            0.3,
            0.3,
            0,
            0, // blue component
            0,
            0,
            0,
            1,
            0, // alpha
        ]);
        image.filters = [gray_filter];
        image.updateCache();
    }

    /**
     * 画像のセピア化
     * @param {type} image
     * @returns {undefined}
     */
    function sepia(image) {
        var sepia_filter = new createjs.ColorMatrixFilter([
            0.39,
            0.77,
            0.19,
            0,
            0, // red component
            0.35,
            0.68,
            0.17,
            0,
            0, // green component
            0.27,
            0.53,
            0.13,
            0,
            0, // blue component
            0,
            0,
            0,
            1,
            0, // alpha
        ]);
        image.filters = [sepia_filter];
        image.updateCache();
    }

    /**
     * アップロードファイルバリデート
     * @param {type} file
     * @returns {Boolean}
     */
    function validator(file) {
        var file_size_max = 5242880;
        if (file === undefined) {
            return false;
        }

        // ファイルサイズ 5MB 制限
        if (file.size > file_size_max) {
            alert(
                "ファイルサイズ5MBまでのファイルをアップロードできます。\nあなたがアップロードしたファイルのサイズ:" +
                    file.size.toString()
            );
            return false;
        }

        //ファイル拡張子
        var ext = getExtenstion(file.name);
        if (
            (ext !== "jpg" || file.type !== "image/jpeg") &&
            (ext !== "jpeg" || file.type !== "image/jpeg") &&
            (ext !== "png" || file.type !== "image/x-png") &&
            (ext !== "png" || file.type !== "image/png")
            //&& (ext !== "gif" || file.type !== "image/gif")
        ) {
            alert("画像データのファイルをアップロードして下さい");
            return false;
        }

        return true;
    }

    /**
     * 拡張子の取得
     * @param {type} file
     * @returns {unresolved}
     */
    function getExtenstion(file) {
        return file.split(".").pop().toLowerCase();
    }

    /**
     * アスペクト比の取得
     * @param {type} width
     * @param {type} height
     * @returns {Number}
     */
    function getAspect(width, height) {
        var quo = 0;
        if (width < height) {
            quo = height / width;
        } else {
            quo = width / height;
        }

        return Math.round(quo * 100) / 100;
    }

    /**
     * 逆アスペクト比の取得
     * @param {type} width
     * @param {type} height
     * @returns {Number}
     */
    function getReversAspect(width, height) {
        var quo = 0;
        if (width < height) {
            quo = width / height;
        } else {
            quo = height / width;
        }

        return Math.round(quo * 100) / 100;
    }

    /**
     * レイアウト画像のアップロード
     * @param {type} image_base64
     * @returns {jqXHR}
     */
    function upload_layout_image(image_base64) {
        let targetpath = image_base64.replace(/^.*,/, "");
        let deferred = new $.Deferred();
        let desing_no =
            item_type === "dt"
                ? $("." + sel_mode_id + ":checked").data("mode")
                : null;
        $.ajax({
            type: "POST",
            url: apiURL + "/fujicart-sc/ordermade/upload-base64.php",
            data: {
                image_base64: targetpath,
                item_type: item_type,
                mode: order_mode,
                desing_no: desing_no,
                design1: $("#original_design_1_name").val(),
                design2: $("#original_design_2_name").val(),
                gadget: $("#gadget_id").val(),
                size: gadSize, //@see ordermade/index.tpl
                collage: collage_data,
            },
            dataType: "json",
            headers: { "X-Shopify-Access-Token": apiToken },
            crossDomain: true,
            timeout: timeout_limit,
        })
            .done(function (data) {
                //console.log(data);
                deferred.resolve(data);
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                //console.log(textStatus);
                deferred.reject(jqXHR); // エラー情報を拒否として扱う
            });

        //完了を知らせるためにDeferredオブジェクトを生成しそれを返す
        return deferred.promise(); // Promiseを返す
    }

    /**
     * オリジナル画像のアップロード
     * @param formオブジェクト
     * @returns {undefined}
     */
    function upload_image(obj) {
        var files = $(obj).prop("files")[0];

        var fd = new FormData();
        fd.append(obj.id, files);
        //fd.append("image_type", $('#color option:selected').val());
        fd.append("image_type", 0); //画面上カラー変更オフの場合は0に設定
        fd.append("image_id", obj.id);

        var deferred = new $.Deferred();
        $.ajax({
            type: "POST",
            url: apiURL + "/fujicart-sc/ordermade/upload-json.php",
            data: fd,
            processData: false,
            contentType: false,
            dataType: "text",
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                "X-Shopify-Access-Token": apiToken,
            },
            crossDomain: true,
            timeout: timeout_limit,
        })
            .done(function (data) {
                deferred.resolve(data);
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                deferred.resolve(textStatus);
            });

        return deferred;
    }

    /*
     * 画像UPロードボタンを押した時の処理
     * @param obj 画像UPボタン
     */
    function setOriginalImage(obj) {
        var files = obj.files;

        if (!validator(files[0])) {
            $(obj).val("");
            return false;
        }

        exeUploadImage(obj, true);
    }

    /**
     * 画像アップロード実行
     * @param obj input type=fileオブジェクト
     * @param isCanvas true:canvasタグ描画
     */
    function exeUploadImage(obj, isCanvas) {
        // オリジナル画像をアップロードして
        var files = obj.files;
        var objId = obj.id;
        if (files === undefined) {
            files = obj[0].files;
            objId = obj[0].id;
        }
        $.blockUI({ message: $("#domMessage") }); //BlockingUI @see /ordermade/script.js
        var deferred = upload_image(obj);
        deferred
            .done(function (result) {
                if (
                    typeof result === "string" &&
                    result.match(/.jpg|.jpeg|.png|.gif/)
                ) {
                    //OKの場合、サーバー側で加工したファイル名がかえされる
                    // アップロードした画像を form に設定
                    $("#" + objId + "_name").val(result);
                    if (isCanvas) {
                        //load-image.all.min.jsのライブラリ処理ではExif対応で修正された画像がHTML5のcanvasタグとして戻される
                        setUpImage(files[0], function (canvas_tag) {
                            imageLoad(canvas_tag.toDataURL());
                        });
                    }
                    $.unblockUI(); //BlockingUI @see /ordermade/script.js
                    return true;
                } else {
                    // upload error
                    $.unblockUI(); //BlockingUI @see /ordermade/script.js
                    alert(
                        "画像アップロード時にエラーが発生しました。もう一度試すか、お問い合わせよりご連絡下さい。"
                    );
                    return false;
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                // upload error
                $.unblockUI(); //BlockingUI @see /ordermade/script.js
                alert(
                    "画像アップロード時にエラーが発生しました。もう一度試すか、お問い合わせよりご連絡下さい。"
                );
                return false;
            });
    }

    /**
     * スマホ画像のExifの取り扱い対応（横向き画像になる件）
     * @param UPされたファイルオブジェクト
     * @param load-image.all.min.jsのライブラリ処理で修正画像読み込み時に行うcallback関数
     */
    function setUpImage(file, callback) {
        // canvas: true にすると canvas に画像を描画する(回転させる場合は必須オプション)
        var options = { canvas: true };
        //@see load-image.all.min.js
        loadImage.parseMetaData(file, function (data) {
            if (data.exif) {
                // options の orientation は小文字。 exif.getの 'Orientation' は先頭大文字
                // ここでcanvasの回転を指定している
                options.orientation = data.exif.get("Orientation");
                //console.log('Orientation: ' + options.orientation);
            }
            // 画像の読み込み。完了時に callback が呼び出される(@see load-image.all.min.js)
            loadImage(file, callback, options);
        });
    }

    /**
     * カラー調整でデザインデータを再度UPロード
     */
    function updateDesingImage() {
        var obj1 = $("#original_design_1");
        var obj2 = $("#original_design_2");

        if (obj1.val() !== "") {
            exeUploadImage(obj1, false);
        }

        if (obj2.val() !== "") {
            exeUploadImage(obj2, false);
        }
    }

    function isset(data) {
        if (data === "" || data === null || data === undefined) {
            return false;
        } else {
            return true;
        }
    }
});
